"use client";

import { Button, Flex, Input, Stack, Text } from "@chakra-ui/react";
import { Field } from "@components/ui/field";
import { useCallback } from "react";
import { LuSearch } from "react-icons/lu";

interface TrackingNumberInputProps {
  value: string;
  onChange: (value: string) => void;
  onSearch: () => void;
  searching?: boolean;
}

const TrackingNumberInput = ({
  value,
  onChange,
  onSearch,
  searching,
}: TrackingNumberInputProps) => {
  const onKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") {
        e.preventDefault();
        onSearch();
      }
    },
    [onSearch],
  );

  const onChangeCb = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value);
    },
    [onChange],
  );

  return (
    <Stack gap={2}>
      <Text fontSize="sm" fontWeight="medium" color="text.primary">
        Enter ELK tracking number
      </Text>
      <Flex gap={2}>
        <Field flex={1}>
          <Input
            placeholder="e.g. ELKU1234567"
            value={value}
            onChange={onChangeCb}
            onKeyDown={onKeyDown}
            size="md"
            borderColor="border.light"
          />
        </Field>
        <Button
          size="md"
          onClick={onSearch}
          disabled={value.trim() === "" || searching === true}
          loading={searching === true}
          loadingText="Searching"
        >
          <LuSearch />
          Search
        </Button>
      </Flex>
    </Stack>
  );
};

export default TrackingNumberInput;
